import { render } from "./CasesLogs.vue?vue&type=template&id=a138baa8"
import script from "./CasesLogs.vue?vue&type=script&lang=js"
export * from "./CasesLogs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/logs/CasesLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a138baa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a138baa8', __exports__)) {
    console.log('reload')
    api.reload('a138baa8', __exports__)
  }
  
  module.hot.accept("./CasesLogs.vue?vue&type=template&id=a138baa8", () => {
    console.log('re-render')
    api.rerender('a138baa8', render)
  })

}


export default __exports__